<section class="unsubscribed-sec">
    <div class="unsubscribed-head">Unsubscribed!</div>
    <div class="unsubscribed-text">You have been unsubscribed successfully from broadcast messages.</div>
    <div class="unsubscribed-btn"><button (click)="backToHome()" class="btn btn-primary-btn">Back to Home</button></div>
</section>
